<template>
    <div>
        <v-card flat outlined class="pa-4">
            <v-card flat outlined class="mb-4" v-for="main_group in indicators.main_groups" :key="main_group.main_group_code">
                <v-card-title class="py-2">
                    {{ main_group.main_group_code }} | {{ main_group.main_group_name }}
                </v-card-title>
                <v-divider/>
                <v-expansion-panels flat :value="0">
                    <v-expansion-panel v-for="group in main_group.groups" :key="group.group_code" >
                        <v-divider/>
                        <v-expansion-panel-header>
                            {{ group.group_code }} | {{ group.group_name }}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-data-table
                                :headers="headers"
                                :items="mapItems(group.data)"
                                multi-sort
                                class="table"
                                hide-default-footer
                                :search="search"
                                :items-per-page="-1"
                            >
                                <template #no-data>
                                    <span>{{ $t('indicators.indicators_list.no_records_found') }}</span>
                                </template>
                                <template #item.actions="{ item }">
                                    <v-btn
                                            class='btn-icon--primary btn-icon'
                                            @click='editIndicator(item)'
                                            v-if="canEdit && indicators.academic_period_current == 1"
                                        ><v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                    <v-btn
                                        class='btn-icon--primary btn-icon'
                                        @click='watchIndicatorDetails(item)'
                                        v-if="hasDetails(item)"
                                    ><v-icon>mdi-eye</v-icon>
                                    </v-btn>
                                </template>
                            </v-data-table>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-card>
        </v-card>
        <editing-dialog
            :showDialog="showEditingDialog"
            :indicator="indicatorToEdit"
            :headers="this.editionHeaders"
            @cancelEditingDialog="hideEditingDialog"/>
        <indicator-details-dialog
            :showDialog="showIndicatorDetailsDialog"
            :indicator="indicatorToEdit"
            @cancelEditingDialog="hideIndicatorDetailDialog"/>
    </div>
</template>

<script>
import {i18n} from "@/i18n";
import EditingDialog from "./EditingDialog";
import IndicatorDetailsDialog from "./IndicatorDetailsDialog";
import {IndicatorsStore} from "@/Store/Indicators/IndicatorsStore";
import {AcademicPeriodsStore} from "@/Store/Indicators/AcademicPeriodsStore";
import {mapState, mapActions} from "pinia";

export default {
    name: "IndicatorsEdition",

    components: {EditingDialog, IndicatorDetailsDialog},

    props: {
        search: {
            type: String,
            required: true,
        },
        indicatorBookId: '',
        academicPeriodId: '',
        canEdit: {
            type: Boolean,
            default: true,
        }
    },

    data() {
        return {
            showEditingDialog: false,
            showIndicatorDetailsDialog: false,
            indicatorToEdit: {},
            expand_default: 0,
            headers: [
                { text: i18n.t('indicators.indicators_list.headers.code'),
                    align: 'start',
                    value: 'indicator_type_code'
                },
                { text: i18n.t('indicators.indicators_list.headers.name'),
                    value: 'indicator_type_name'
                },
            ],
            // sparkHeaders: [],
            editionHeaders: [],
        }
    },

    computed:{
        ...mapState(IndicatorsStore, ['indicators']),
        ...mapState(AcademicPeriodsStore, ['academicPeriods']),

    },

    methods: {
        /**
         *
         * @param indicator
         * @returns {boolean}
         */
        hasDetails(indicator){
            return indicator.hasDetails;
        },

        /**
         *
         * @param {*} indicator
         */
        editIndicator(indicator) {
            this.indicatorToEdit = indicator
            this.showEditingDialog = true
        },

        watchIndicatorDetails(indicator) {
            this.indicatorToEdit = indicator
            this.showIndicatorDetailsDialog = true
        },

        hideEditingDialog() {
            this.showEditingDialog = false
        },

        hideIndicatorDetailDialog() {
            this.showIndicatorDetailsDialog = false
        },

        mapItems(object){
            let result = [];
            for (const [key, value] of Object.entries(object)) {
                    let entries  = Object.entries(value)
                    let item = [];
                    for (const [key_, value_] of entries) {
                        item[key_] = value_;
                    }
                    result.push(Object.assign({}, item));
            }
            return result;
        },

        /**
         *
         * @param {*} main_group
         */
         first_expand_open(main_group) {
            return (this.indicators.first_main_group_code === main_group.main_group_code) ? 0 : []
        },

        ...mapActions(IndicatorsStore, [
            'getIndicatorBook',
        ]),
        ...mapActions(AcademicPeriodsStore, [
            'getHistoricAcademicPeriods',
        ]),
    },


    mounted() {

        this.getHistoricAcademicPeriods(this.academicPeriodId).then(() => {
            let items = [];
            for (const [key, value] of Object.entries(this.academicPeriods)) {
                let item = [];
                item['text'] = value.name;
                item['value'] = value.final_year.toString();
                item['align'] = 'center';
                this.headers.push(Object.assign({}, item));
                // this.sparkHeaders.push(value.name);
                this.editionHeaders.push(Object.assign({}, item));
                item = null;
            }
            this.headers.push({
                align: 'left',
                value:'actions',
                sortable: false
            });

            this.getIndicatorBook(this.indicatorBookId);
        }).catch(() => { });
    },

}
</script>

<style scoped>

</style>
